import {apiServer, get} from '../../api';

export const loadCommissions = ()=>{
    return (dispatch, getState)=>{
        get(apiServer+'/v1/user/commissions')
            .then((data)=>{
                if(data.commissions){
                    dispatch({
                        type:'set-commissions',
                        commissions: data.commissions[0]
                    })
                }
            })
    }
}
